import React from "react";
import { Modal } from "react-bootstrap";
import GraphQuestionsGrid from "./GraphQuestionsGrid";
import QuestionBarChart from "../charts/QuestionBarChart";
import QuestionDropDownChart from "../charts/QuestionDropDownChart";
import QuestionMCQChart from "../charts/QuestionMCQChart";
import QuestionGroupRatingChart from "../charts/QuestionGroupRatingChart";
import QuestionMultipleMCQChart from "../charts/QuestionMultipleMCQChart";
import QuestionRatingChart from "../charts/QuestionRatingChart";
import TextQuestionsGrid from "./TextQuestionsGrid";
import QuestionGroupRatingGrid from "../Grid/QuestionGroupRatingGrid";
import {
  ExcelSurveyStartLabel,
  ExcelSurveyEndLabel,
  ExcelSurveyStartDate,
  ExcelSurveyEndDate,
} from "../../common/DateFormat";

const PrintGrid = ({ show, handleClose, modalQuestion, questionNo, surveyDetails }) => {
  return (
    <Modal
      show={show}
      animation={true}
      onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {questionNo}. {modalQuestion.QuestionText}
          <small className="total-responses d-block mt-2 text-muted">
            Responses: {modalQuestion.totalquestionResponses}
          </small>
        </Modal.Title>
      </Modal.Header>
      {(() => {
        switch (modalQuestion.AnswerTypeId) {
          case "b166063b-0740-11ec-af38-1908de41ac9c":
            return (
              <Modal.Body>
                {modalQuestion.totalquestionResponses == 0 ? (
                  <small className="d-block text-danger mt-1 fw-light">
                    No response record found for this question
                  </small>
                ) : (
                  <QuestionMCQChart
                    chartData={modalQuestion.child}
                    QuestionNo={questionNo}
                    QuestionText={modalQuestion.QuestionText}
                    surveyDetails={surveyDetails}
                    QuestionDetails={modalQuestion}
                    Key={"chart_text"}
                    Value={"responses"}
                    optionText={"option_text"}
                    divId={`graph_${questionNo * 5}`}
                  />
                )}
                <div className="mt-5">
                  <GraphQuestionsGrid
                    gridData={modalQuestion.child}
                    QuestionNo={questionNo}
                    surveyDetails={surveyDetails}
                    QuestionText={modalQuestion.QuestionText}
                    QuestionDetails={modalQuestion}
                  />
                </div>
                {modalQuestion.otherData.length > 0 ? (
                  <>
                    <div className="text-center total-responses d-block p-2 text-muted">
                      <b>Other Responses ({modalQuestion.otherData.length})</b>
                    </div>
                    <TextQuestionsGrid
                      gridData={modalQuestion.otherData}
                      surveyDetails={surveyDetails}
                      QuestionText={modalQuestion.QuestionText}
                      QuestionNo={questionNo}
                    />
                  </>
                ) : (
                  <></>
                )}
              </Modal.Body>
            );
          case "b1662a30-0740-11ec-af38-1908de41ac9c":
            return (
              <Modal.Body>
                {modalQuestion.totalquestionResponses == 0 ? (
                  <small className="d-block text-danger mt-1 fw-light">
                    No response record found for this question
                  </small>
                ) : (
                  <QuestionDropDownChart
                    chartData={modalQuestion.child}
                    QuestionNo={questionNo}
                    QuestionText={modalQuestion.QuestionText}
                    surveyDetails={surveyDetails}
                    QuestionDetails={modalQuestion}
                    Key={"chart_text"}
                    Value={"responses"}
                    optionText={"option_text"}
                    divId={`graph_${questionNo * 5}`}
                  />
                )}
                <div className="mt-5">
                  <GraphQuestionsGrid
                    gridData={modalQuestion.child}
                    QuestionNo={questionNo}
                    surveyDetails={surveyDetails}
                    QuestionText={modalQuestion.QuestionText}
                    QuestionDetails={modalQuestion}
                  />
                </div>
              </Modal.Body>
            );

          case "b1662e42-0740-11ec-af38-1908de41ac9c":
            return (
              <Modal.Body>
                {modalQuestion.totalquestionResponses == 0 ? (
                  <small className="d-block text-danger mt-1 fw-light">
                    No response record found for this question
                  </small>
                ) : (
                  <QuestionMultipleMCQChart
                    chartData={modalQuestion.child}
                    QuestionNo={questionNo}
                    QuestionText={modalQuestion.QuestionText}
                    surveyDetails={surveyDetails}
                    QuestionDetails={modalQuestion}
                    Key={"chart_text"}
                    Value={"responses"}
                    optionText={"option_text"}
                    divId={`graph_${questionNo * 5}`}
                  />
                )}
                <div className="mt-5">
                  <GraphQuestionsGrid
                    gridData={modalQuestion.child}
                    QuestionNo={questionNo}
                    surveyDetails={surveyDetails}
                    QuestionText={modalQuestion.QuestionText}
                    QuestionDetails={modalQuestion}
                  />
                </div>
              </Modal.Body>
            );
          case "77b55f4a-639e-4708-9412-5b46f7e3972b":
            return (
              <Modal.Body>
                {modalQuestion.totalquestionResponses == 0 ? (
                  <small className="d-block text-danger mt-1 fw-light">
                    No response record found for this question
                  </small>
                ) : (
                  <QuestionRatingChart
                    chartData={modalQuestion.child}
                    QuestionNo={questionNo}
                    QuestionText={modalQuestion.QuestionText}
                    surveyDetails={surveyDetails}
                    QuestionDetails={modalQuestion}
                    Key={"option_text"}
                    Value={"responses"}
                    optionText={"option_text"}
                    divId={`graph_${questionNo * 5}`}
                  />
                )}
                <div className="mt-5">
                  <GraphQuestionsGrid
                    gridData={modalQuestion.child}
                    QuestionNo={questionNo}
                    surveyDetails={surveyDetails}
                    QuestionText={modalQuestion.QuestionText}
                    QuestionDetails={modalQuestion}
                  />
                </div>
              </Modal.Body>
            );
          case "ec856a6e-a071-4496-829e-ce407ad3d3fa":
            return (
              <Modal.Body>
                {modalQuestion.totalquestionResponses == 0 ? (
                  <small className="d-block text-danger mt-1 fw-light">
                    No response record found for this question
                  </small>
                ) : (
                  <QuestionGroupRatingChart
                    chartData={modalQuestion.child}
                    QuestionNo={questionNo}
                    QuestionText={modalQuestion.QuestionText}
                    surveyDetails={surveyDetails}
                    QuestionDetails={modalQuestion}
                    Key={"chart_text"}
                    Value={"visits"}
                    optionText={"option_text"}
                    divId={`graph_${questionNo * 5}`}
                  />
                )}
                <div className="mt-5">
                  <QuestionGroupRatingGrid
                    gridData={modalQuestion.child}
                    QuestionNo={questionNo}
                    surveyDetails={surveyDetails}
                    QuestionText={modalQuestion.QuestionText}
                  />
                </div>
              </Modal.Body>
            );
          default:
            return (
              <Modal.Body>
                {modalQuestion.totalquestionResponses == 0 ? (
                  <small className="d-block text-danger mt-1 fw-light">
                    No response record found for this question
                  </small>
                ) : (
                  <div className="individual-graph popup-table">
                    <TextQuestionsGrid
                      gridData={modalQuestion.child}
                      QuestionNo={questionNo}
                      surveyDetails={surveyDetails}
                      QuestionText={modalQuestion.QuestionText}
                    />
                  </div>
                )}
              </Modal.Body>
            );
        }
      })()}
      {/* <Modal.Footer>
        <Button onClick={handleClose}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  );
};

export default PrintGrid;
